import { render, staticRenderFns } from "./cogs.vue?vue&type=template&id=b706aaa0&"
import script from "./cogs.vue?vue&type=script&lang=js&"
export * from "./cogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports